import { replace } from 'lodash-es';

const appendScriptToBody = ({ script, name, logError }) => {
  if (document.querySelector('body')) {
    document.querySelector('body').appendChild(script);
  } else {
    const e = new Error(`Failed to inject ${name} script`);
    logError(e);
  }
};

// this injects window.google and not the legacy window.gapi JS api
export const injectGoogleScript = ({ callback, logError }) => {
  if (!window.google) {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = callback;
    script.id = 'google-client-script';
    appendScriptToBody({ script, name: 'google gsi', logError });
  } else {
    callback();
  }
};

export const injectAppleScript = ({ logError, locale = 'en_US' }) => {
  if (!window.AppleID) {
    const script = window.document.createElement('script');
    const formattedLocale = replace(locale, '-', '_');
    script.src = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${formattedLocale}/appleid.auth.js`;
    script.async = true;
    appendScriptToBody({ script, name: 'apple', logError });
  }
};

export const injectFacebookScript = ({
  logError,
  appId,
  version,
  callback,
  locale = 'en_US'
}) => {
  // make sure haml FB injection has not already injected script and also make sure nothing else
  // has injected FB script
  if (!window.Strava?.fbInitialized && !window.FB) {
    window.fbAsyncInit = () => {
      // ref - https://developers.facebook.com/docs/javascript/reference/FB.init/v13.0
      window.FB.init({
        appId,
        xfbml: true,
        version,
        status: true,
        cookie: true
      });
      callback();
    };

    // facebook uses format ll_CC - see https://developers.facebook.com/docs/javascript/internationalization
    const formattedLocale = replace(locale, '-', '_');

    const script = window.document.createElement('script');
    script.src = `https://connect.facebook.net/${formattedLocale}/sdk.js`;
    script.async = true;
    appendScriptToBody({ script, name: 'facebook-jssdk', logError });
  } else {
    callback();
  }
};

export default { injectGoogleScript, injectAppleScript, injectFacebookScript };
